import type { InputHTMLAttributes } from 'react';
import { TextField, type TextFieldCommonProps } from './TextField';

export type TextInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> &
  TextFieldCommonProps;

/**
 * Wrap on HTML input of type "text" in a SG Bootstrap 5 components.
 *
 * @example
 * <TextInput purpose="primary" size="lg" />
 */
export const TextInput = (props: TextInputProps) => <TextField tag="input" {...props} />;
